const application = {
  // Page Title
  pageTitle: 'Application Form',
  pageSubtitle: 'Join SAI College for Chinese Language Education',
  
  // Progress Steps
  steps: {
    personal: 'Personal Information',
    contact: 'Contact Information',
    academic: 'Academic Information',
    documents: 'Required Documents',
    motivation: 'Motivation & Goals',
    review: 'Review & Submit'
  },
  
  // Personal Information
  personal: {
    title: 'Personal Information',
    subtitle: 'Please enter your personal information accurately',
    fullName: 'Full Name (Arabic)',
    fullNamePlaceholder: 'Enter your full name in Arabic',
    fullNameEn: 'Full Name (English)',
    fullNameEnPlaceholder: 'Enter your full name in English',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    nationality: 'Nationality',
    nationalityPlaceholder: 'Select your nationality',
    idNumber: 'ID/Passport Number',
    idNumberPlaceholder: 'Enter your ID or passport number',
    placeOfBirth: 'Place of Birth',
    placeOfBirthPlaceholder: 'Enter your place of birth'
  },
  
  // Contact Information
  contact: {
    title: 'Contact Information',
    subtitle: 'How can we reach you?',
    phone: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    whatsapp: 'WhatsApp Number',
    whatsappPlaceholder: 'Enter your WhatsApp number',
    email: 'Email Address',
    emailPlaceholder: 'Enter your email address',
    address: 'Address',
    addressPlaceholder: 'Enter your complete address',
    city: 'City',
    cityPlaceholder: 'Enter your city',
    emergencyContact: 'Emergency Contact',
    emergencyContactPlaceholder: 'Name and phone number',
    emergencyRelation: 'Relationship',
    emergencyRelationPlaceholder: 'e.g., Father, Brother, Friend'
  },
  
  // Academic Information
  academic: {
    title: 'Academic Information',
    subtitle: 'Tell us about your educational background',
    program: 'Desired Program',
    programPlaceholder: 'Select a program',
    hsk1: 'HSK Level 1',
    hsk2: 'HSK Level 2',
    hsk3: 'HSK Level 3',
    hsk4: 'HSK Level 4',
    hsk5: 'HSK Level 5',
    hsk6: 'HSK Level 6',
    yct: 'YCT - Youth Chinese Test',
    businessChinese: 'Business Chinese',
    educationLevel: 'Education Level',
    educationLevelPlaceholder: 'Select your education level',
    highSchool: 'High School',
    diploma: 'Diploma',
    bachelor: 'Bachelor',
    master: 'Master',
    doctorate: 'Doctorate',
    previousSchool: 'Previous School/University',
    previousSchoolPlaceholder: 'Name of educational institution',
    gpa: 'GPA',
    gpaPlaceholder: 'Enter your GPA',
    chineseLevel: 'Current Chinese Level',
    chineseLevelPlaceholder: 'Select your level',
    beginner: 'Beginner',
    elementary: 'Elementary',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    previousChinese: 'Have you studied Chinese before?',
    yes: 'Yes',
    no: 'No',
    previousDetails: 'Previous Study Details',
    previousDetailsPlaceholder: 'Where and when did you study Chinese?'
  },
  
  // Documents
  documents: {
    title: 'Required Documents',
    subtitle: 'Please upload the following documents (PDF or images)',
    photo: 'Personal Photo',
    photoDesc: 'Recent photo with white background',
    idCopy: 'ID/Passport Copy',
    idCopyDesc: 'Clear copy of identification document',
    certificates: 'Academic Certificates',
    certificatesDesc: 'Latest academic certificate obtained',
    transcript: 'Transcript',
    transcriptDesc: 'Transcript of latest academic stage',
    uploadButton: 'Choose File',
    changeButton: 'Change File',
    uploaded: 'Uploaded',
    notUploaded: 'Not Uploaded',
    maxSize: 'Max size: 5 MB',
    supportedFormats: 'Supported formats: JPG, PNG, PDF'
  },
  
  // Motivation
  motivation: {
    title: 'Motivation & Goals',
    subtitle: 'Tell us about your motivations and goals',
    whyStudy: 'Why do you want to study Chinese?',
    whyStudyPlaceholder: 'Explain your motivation for learning Chinese (150-500 characters)',
    goals: 'What are your future goals?',
    goalsPlaceholder: 'What do you hope to achieve after mastering Chinese? (150-500 characters)',
    interests: 'Your interests in Chinese culture',
    interestsPlaceholder: 'What interests you about Chinese culture?',
    careerPlans: 'Career Plans',
    careerPlansPlaceholder: 'How will Chinese help your career?',
    charCount: 'Character count'
  },
  
  // Review
  review: {
    title: 'Review Application',
    subtitle: 'Please review all information before submitting',
    personalInfo: 'Personal Information',
    contactInfo: 'Contact Information',
    academicInfo: 'Academic Information',
    documentsInfo: 'Documents',
    motivationInfo: 'Motivation & Goals',
    edit: 'Edit',
    declaration: 'I declare that all information provided is true and accurate',
    terms: 'I agree to the terms and conditions',
    viewTerms: 'View Terms & Conditions'
  },
  
  // Success
  success: {
    title: 'Application Submitted Successfully!',
    subtitle: 'Thank you for applying to SAI College',
    applicationNumber: 'Application Number',
    nextSteps: 'Next Steps',
    step1: 'Your application will be reviewed within 3-5 business days',
    step2: 'We will contact you via email or phone',
    step3: 'You may be asked to attend an interview or placement test',
    step4: 'After acceptance, you will receive an acceptance letter and registration instructions',
    backHome: 'Back to Home',
    viewCourses: 'Browse Courses',
    contactUs: 'Contact Us'
  },
  
  // Buttons
  buttons: {
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit Application',
    save: 'Save',
    cancel: 'Cancel'
  },
  
  // Validation
  validation: {
    required: 'This field is required',
    invalidEmail: 'Invalid email address',
    invalidPhone: 'Invalid phone number',
    minLength: 'Must contain at least {min} characters',
    maxLength: 'Must not exceed {max} characters',
    fileSize: 'File size must not exceed 5 MB',
    fileType: 'File type not supported'
  }
};

export default application;